import { Dispatch } from 'redux';

import { updateUser } from './users';
import * as api from '../utils/api';
import { notifyError } from '../utils/functions';

interface ReportState {
  data?: IReportData;
  loadDate: string; // This is the date and time the report was last loaded
  reportSettingsPaneOpen: boolean;
}

export const actions = {
  CLEAR_REPORT_DATA: 'lms-ui/report/CLEAR_REPORT_DATA',
  GET_REPORT_DATA: 'lms-ui/report/GET_REPORT_DATA',
  UPDATE_LOAD_DATE: 'lms-ui/report/UPDATE_LOAD_DATE',
  REPORT_SETTINGS_PANE_TOGGLE: 'lms-ui/report/REPORT_SETTINGS_PANE_TOGGLE',
};

interface ReportAction {
  type:
    | typeof actions.CLEAR_REPORT_DATA
    | typeof actions.GET_REPORT_DATA
    | typeof actions.UPDATE_LOAD_DATE;
  payload: IReportData | string;
}

type ReportActionTypes = ReportAction;

const initialState: ReportState = {
  data: undefined,
  loadDate: new Date().toISOString(),
  reportSettingsPaneOpen: true,
};

export const clearReportData = () => {
  return {
    type: actions.CLEAR_REPORT_DATA,
  };
};

export const getTeamManagerReportData = () => async (dispatch: Dispatch) => {
  try {
    const response = await api.getTeamManagerReportData();
    const data = response.data as IReportRow[];
    dispatch({ type: actions.GET_REPORT_DATA, payload: data });
  } catch (e) {
    notifyError(e, dispatch);
  }
};

export const getGeneralReportData = (teamIds: string[]) => async (dispatch: Dispatch) => {
  try {
    const response = await api.getGeneralReportData(teamIds);
    const data = response.data as IReportRow[];
    dispatch({ type: actions.GET_REPORT_DATA, payload: data });
  } catch (e) {
    notifyError(e, dispatch);
  }
};

export const getCLEReportData = (from: Date, to: Date) => async (dispatch: Dispatch) => {
  try {
    const response = await api.getCLEReportData(from, to);
    const data = response.data as IReportRow[];
    dispatch({ type: actions.GET_REPORT_DATA, payload: data });
  } catch (e) {
    notifyError(e, dispatch);
  }
};

export const updateReportSettings =
  ({ user }: { user: IUser }) =>
  async (dispatch: Dispatch) => {
    try {
      await dispatch(updateUser(user, true) as any);
      return Promise.resolve();
    } catch (e) {
      notifyError(e, dispatch);
      return Promise.reject();
    }
  };

export const updateLoadDate = (date: Date) => {
  return {
    type: actions.UPDATE_LOAD_DATE,
    payload: date.toISOString(),
  };
};

export const toggleReportSettingsPane = () => {
  return {
    type: actions.REPORT_SETTINGS_PANE_TOGGLE,
  };
};

export default function reducer(state = initialState, action: ReportActionTypes): ReportState {
  switch (action.type) {
    case actions.GET_REPORT_DATA: {
      return {
        ...state,
        data: action.payload as IReportData,
      };
    }
    case actions.CLEAR_REPORT_DATA: {
      return {
        ...state,
        data: undefined,
      };
    }
    case actions.UPDATE_LOAD_DATE: {
      return {
        ...state,
        loadDate: action.payload as string,
      };
    }
    case actions.REPORT_SETTINGS_PANE_TOGGLE: {
      return {
        ...state,
        reportSettingsPaneOpen: !state.reportSettingsPaneOpen,
      };
    }
    default:
      return state;
  }
}
